import { Global, Collection } from '@sourceflow-uk/sourceflow-sdk';
import SeoHead from '../../components/SeoHead';
import MainBanner from '../../components/MainBanner';
import GetInTouch from '../../components/GetInTouch';
import MultiColumnCTAWithDivider from '../../components/MultiColumnCTAWithDivider';

export default function ContactUsPage({
    global,
    all_branches
}) {
    return (
        <>
            <SeoHead
                page_name={`Contact Us | Staffing Agency | US and Canada Staffing | Bartech Staffing`}
                canonical_link={`contact-us`}
            />
            <MainBanner
                global={global}
                pathPrefix={`contact_us_page.main_banner`}
                customClass={``}
                content={
                    <>
                        <h1>Contact Us</h1>
                    </>
                }
                imageURL1={`/site-assets/images/main-banner.jpg`}
                imageALT1={`Main Banner`}
                imageURL2={`/site-assets/images/main-banner-overlay.jpg`}
                imageALT2={`Overlay Main Banner`}
            />
            <GetInTouch
                global={global}
                pathPrefix={`contact_us_page.get_in_touch`}
                customClass={`py-5 grayGradientBg`}
                content={
                    <>
                        <h2>Get in Touch!</h2>
                        <p>There are many way to get in touch.</p>
                    </>
                }
                content_2={
                    <>
                        <h3>
                            Send Us Your CV/Resume
                        </h3>
                    </>
                }
                buttonLink={`/`}
                buttonTitle={`Submit your CV/Resume`}
                popUpModal_1={true}
                popUpModal_1_form_id={`93245ba9-08ec-457f-825c-8e7d01754a58`}
                dialog_content_1={
                    <>
                        <h5>Submit your CV/Resume</h5>
                    </>
                }
                post={all_branches}
                successPageUrl={`/contact-us/submission-success`}
            />
            <MultiColumnCTAWithDivider
                global={global}
                pathPrefix={`contact_us_page.multi_column_cta`}
                customClass={`pt-5 pb-md-4 pb-5`}
                left_content={
                    <>
                        <h2>Get in Touch</h2>
                    </>
                }
                right_content={
                    <>
                        <h2>Newsletter Sign up</h2>
                    </>
                }
                buttonLink2={`/`}
                buttonLink1={`/contact-us/`}
                buttonTitle1={`Contact us`}
                buttonTitle2={`For Candidates`}
                buttonLink2_1={`/`}
                buttonTitle2_1={`For Clients`}
                popUpModal_1={true}
                popUpModal_2={true}
                popUpModal_1_form_id={`6d27433b-0a16-4df0-813c-8cf5e35e6b66`}
                popUpModal_2_form_id={`6952b945-8c29-4f45-b771-ebeab17400ef`}
                dialog_content_1={
                    <h5>For candidates</h5>
                }
                dialog_content_2={
                    <h5>For clients</h5>
                }
                successPageUrl={`/contact-us/submission-success`}
            />
        </>
    )
}

export async function getStaticProps({ params }) {
    const global = (await Global()).toJson();

    const branches = await Collection('branches_us');

    const all_branches = branches.orderBy('_order').getItems();
    return {
        props: {
            global,
            all_branches
        }
    };
}
